module.exports = __webpack_public_path__ + "img/ducere-de-mana-1777-pagina-de-titlu-big.b9d29892.jpg";